/*jshint esversion: 6 */

import { RANDOM_ERROR, QUIZ_STARTED, QUESTIONS_RECEIVED, QUIZ_LOADED, QUIZ_COMPLETE, TIMER_TICK, REQUIRE_AUTH } from '../actions/quizActions';
import { addState, resetState } from '../helpers/stateHelper';

const initialState = {
    state: 0,
    currentQuestion: -1,
    questions: [],
};

const quizReducer = function(state = initialState, action) {

    switch ( action.type ) {

        case QUIZ_STARTED:

            const { timeStart, question, startDate, timeLeft} = action.payload;

            return Object.assign({}, state, {
                state: resetState(action.type),
                questions: state.questions.concat(question),
                startDate,
                timeStart,
                timeLeft
            });

        case RANDOM_ERROR:
            return Object.assign({}, state, {
                state: resetState(action.type),
                error: {title: action.title, body: action.body}
            });

        case REQUIRE_AUTH:
            return Object.assign({}, state, {
                state: resetState(action.type),
                error: {title: action.title, body: action.body}
            });

        case TIMER_TICK:
            return Object.assign({}, state, action.payload);

        case QUIZ_LOADED:
            return Object.assign(
                {}, state,
                {
                    state: addState(state.state, action.state) & ~REQUIRE_AUTH,
                    post: action.quiz,
                    loading: false
                }
            );

        case QUESTIONS_RECEIVED:
            return Object.assign({}, state, {
                    loading: false,
                    state: addState(state.state, action.state),
                    questions: state.questions.concat(action.question)
            });


        case QUIZ_COMPLETE:
            return Object.assign({}, state, {
                state: resetState(action.type),
            });

        default:
            return state;
    }
};

export default quizReducer;
